import React from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';

import style from './SharedZoneNewOffers.module.pcss';

const cx = classNames.bind(style);

const SharedZoneNewOffers = ({ services, title }) => (
  <div className={cx('wrap')}>
    {!!title && (
      <div className={cx('title')}>
        <Text size="size2-m">{title}</Text>
      </div>
    )}
    {!!services.length && (
      <div className={cx('services')}>
        {services.map(({ imageUrl, subtitle, alt }) => (
          <div key={imageUrl} className={cx('service')}>
            {imageUrl && (
              <div className={cx('picture')}>
                <img src={imageUrl} loading="lazy" alt={alt} />
              </div>
            )}
            {subtitle && (
              <div className={cx('subtitle')}>
                <Text size="size4-m">{subtitle}</Text>
              </div>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
);

export { SharedZoneNewOffers };
